import type { PlayerType } from '../../../../types'

export const getPlayerSeatReserveTime = (
  player: PlayerType | null,
  type: 'PUBLIC' | 'PRIVATE',
): number => {
  if (!player) {
    return 0
  }
  const now = new Date().getTime()
  const joinedAt = new Date(player.joinedAt).getTime()
  if (player.status === 'IDLE') {
    const lastAction = new Date(player.lastTurnAt || player.joinedAt).getTime()
    // TODO: get a real time
    const permittedAfkDuration = (type === 'PUBLIC' ? 3 : 30) * 60_000
    const diff = now - lastAction + permittedAfkDuration
    return diff < 0 ? 0 : diff
  }
  if (player.status === 'RESERVE') {
    const diff = now - joinedAt + 60_000
    return diff < 0 ? 0 : diff
  }

  return 0
}
